import {Fill, Stroke, Style, Icon} from "ol/style";
import {Point} from 'ol/geom';
import pinIconSrc from './pin-blue.png';

const pinWidth = 41;
const pinHeight = 64;

const pinStyle = new Style({
    image: new Icon({
        src: pinIconSrc,
        scale: 0.5,
        anchor: [0.5, 1.0],
        size: [pinWidth, pinHeight],
        opacity: 0.91
    }),
    zIndex: 3
})

const RED = '#FF3F3F';
const RED2 = '#FF3F3F65';


const ORANGE = '#f7b62b';
const ORANGE2 = '#f7b62b60';

const polygonStyle = new Style({
    fill: new Fill({
        color: ORANGE2
    }),
    stroke: new Stroke({
        color: ORANGE,
        width: 2
    })
});

export function vectorStyle(f) {
    return f && f.getGeometry() instanceof Point ? pinStyle : polygonStyle;
}